import { hasProFeatureEntitlement } from '../../common/workspace-entitlements'

export const canAccessSceneWorkflow = (user, options = {}) => {
  return hasProFeatureEntitlement({
    ...options,
    user
  })
}
